import { CartItemDto } from "../../dto/CartItem.dto";

import { CartItemContainer, ItemDetails } from "./cart-item.styles";

const CartItem = ({ cartItem }: { cartItem: CartItemDto }) => {
  const { name, imageUrl, quantity, price } = cartItem;

  return (
    <CartItemContainer>
      <img src={imageUrl} alt={`${name}`} />
      <ItemDetails>
        <span>{name}</span>
        <span>
          {quantity} x ${price}
        </span>
      </ItemDetails>
    </CartItemContainer>
  );
};

export default CartItem;
